import { FirstTimeOnboardingCompletedState } from '@layout/first-time-onboarding/store/state/first-time-onboarding-completed.state';

export const firstTimeOnboardingCompletedStates = [FirstTimeOnboardingCompletedState];
